export default __webpack_public_path__ + "media/images/svg/carousel_arrow-754ec55b85686b24efa312f8ca4c3f5d.svg";